"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const StickyBox_1 = __importDefault(require("@web/common/StickyBox"));
(() => {
    const driverSetMenuElement = document.querySelector('.user-profile-dashboard-driver-set-menu');
    const driverSetContainerElement = document.querySelector('.user-profile-dashboard-driver-set-container');
    if (driverSetMenuElement && driverSetContainerElement) {
        (() => new StickyBox_1.default(driverSetMenuElement, driverSetContainerElement))();
    }
    const toggleTitles = Array.from(document.getElementsByClassName('toggle-title'));
    toggleTitles.forEach((toggleTitle) => {
        toggleTitle.addEventListener('click', (event) => {
            event.preventDefault();
            toggleTitle.classList.toggle('open');
            const toggleContainer = toggleTitle.nextElementSibling;
            if (toggleContainer) {
                toggleContainer.style.display = 'block';
                window.scrollTo({
                    top: toggleContainer.getBoundingClientRect().top + window.scrollY - 70,
                    behavior: 'smooth',
                });
            }
        });
    });
    const menuTargetLinks = Array.from(document.querySelectorAll('.menu-target-link'));
    menuTargetLinks.forEach((menuTargetLink) => {
        menuTargetLink.addEventListener('click', (event) => {
            var _a;
            event.preventDefault();
            menuTargetLinks.forEach((targetLink) => {
                targetLink.classList.remove('active');
            });
            menuTargetLink.classList.add('active');
            const id = (_a = menuTargetLink.getAttribute('href')) === null || _a === void 0 ? void 0 : _a.replace('#', '');
            if (id) {
                const target = document.getElementById(id);
                if (target) {
                    const toggleTitle = target.querySelector('.toggle-title');
                    if (toggleTitle) {
                        toggleTitle.classList.toggle('open');
                        const toggleContainer = toggleTitle.nextElementSibling;
                        if (toggleContainer) {
                            toggleContainer.style.display = 'block';
                        }
                    }
                    window.scrollTo({
                        top: target.getBoundingClientRect().top + window.scrollY,
                        behavior: 'smooth',
                    });
                }
            }
        });
    });
})();
